import { render, staticRenderFns } from "./badgeNavigation.vue?vue&type=template&id=71878d66&scoped=true&"
import script from "./badgeNavigation.vue?vue&type=script&lang=js&"
export * from "./badgeNavigation.vue?vue&type=script&lang=js&"
import style0 from "./badgeNavigation.vue?vue&type=style&index=0&id=71878d66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71878d66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
